import { defineMessages } from '@sm/intl';
var IPPM_COPY = defineMessages({
  // In Product Pricing Component
  back_to_survey: {
    id: 'ippmString.backToSurvey',
    defaultMessage: 'Back to survey',
    description: '[Type: Label][Vis.: high] - This is the link back to the survey that closes IPPM.'
  },
  for_you: {
    id: 'ippmString.forYou',
    defaultMessage: 'FOR YOU',
    description: '[Type: Label][Vis.: high] - Highlights which plan is suggested for the user.'
  },
  responses_per_month: {
    id: 'ippmString.responsesPerMonth',
    defaultMessage: '*{overageCostHtml} per additional response. SurveyMonkey Audience responses sold separately.',
    description: '[Type: Paragraph][Vis.: low] - Footer message specifying the cost per additional overage response.'
  },
  display_pricing_represents: {
    id: 'ippmString.displayPricingRepresents',
    defaultMessage: '*Displayed pricing represents a 10% or more savings per user per month compared to individual Advantage and Premier plans.',
    description: '[Type: Paragraph][Vis.: low] - Footer message clarifying savings.'
  },
  add_on_features: {
    id: 'ippmString.addOnFeatures',
    defaultMessage: '**Add-on features available with Enterprise plan must be purchased separately.',
    description: '[Type: Paragraph][Vis.: low] - Footer message clarifying add-on features for Enterprise plans.'
  },
  individual_plans: {
    id: 'ippmString.individualPlans',
    defaultMessage: 'Individual plans',
    description: '[Type: Label][Vis.: high] - This is the label for the individual plans column.'
  },
  team_plans: {
    id: 'ippmString.teamPlans',
    defaultMessage: 'Team plans',
    description: '[Type: Label][Vis.: high] - This is the label for the team plans column.'
  },
  your_survey_includes: {
    id: 'ippmString.yourSurveyIncludes',
    defaultMessage: 'Your survey includes paid features',
    description: '[Type: Header][Vis.: high] - Message in the header about what triggered this modal.'
  },
  choose_a_plan: {
    id: 'ippmString.chooseAPlan',
    defaultMessage: 'Choose a plan to keep your added features. Or <button type="button" id="return-to-survey" class="wds-button wds-button--link wds-button--text wds-p-0 wds-type--link">return to your survey</button> and remove paid features to send for free.',
    description: '[Type: Header][Vis.: high] - Instruction in the header for what to do next.'
  },
  do_more: {
    id: 'ippmString.doMore',
    defaultMessage: 'Do more with a paid plan',
    description: '[Type: Header][Vis.: high] - Modal header.'
  },
  get_our_best: {
    id: 'ippmString.getOurBest',
    defaultMessage: 'Get our best features and more responses.',
    description: '[Type: Header][Vis.: high] - Modal subheader.'
  },
  also_included_in: {
    id: 'ippmString.alsoIncludedIn',
    defaultMessage: 'Also included in {label}',
    description: '[Type: Label][Vis.: high] - Section label to indicate features that are included in paid plans.'
  },
  included_in: {
    id: 'ippmString.includedIn',
    defaultMessage: 'Included in {label}',
    description: '[Type: Label][Vis.: high] - Section label to indicate features that are included in paid plans.'
  },
  paid_features_in_your: {
    id: 'ippmString.paidFeaturesInYour',
    defaultMessage: 'Paid features in your survey',
    description: "[Type: Label][Vis.: high] - Section label to indicate paid features that are in the user's survey."
  },
  select_plan: {
    id: 'ippmString.selectPlan',
    defaultMessage: 'SELECT',
    description: '[Type: Button][Vis.: high] - Button to select a plan.'
  },
  contact_us: {
    id: 'ippmString.contactUs',
    defaultMessage: 'CONTACT US',
    description: '[Type: Button][Vis.: high] - Button to select enterprise, which requires contacting sales.'
  },
  edu_discount: {
    id: 'ippmString.eduDiscount',
    defaultMessage: 'We offer discounted pricing for students and educators. <a href="/pricing/individual/?e=edu_faq&ut_source=ippm" target="_parent" class="edu_pricing_link_1095 wds-m-l-1">See pricing</a>',
    description: '[Type: Header][Vis.: high] - Subheader that is shown to users who are potentially eligible for the educational discount.'
  },
  // headers
  watermark_header: {
    id: 'ippmString.watermarkHeader',
    defaultMessage: 'Remove watermark',
    description: '[Type: Header][Vis.: high] - Header variation for when we are highlighting the watermark feature.'
  },
  watermark_subheader: {
    id: 'ippmString.watermarkSubheader',
    defaultMessage: 'Choose a plan to remove watermark, share, export your results and so much more',
    description: '[Type: Header][Vis.: high] - Subheader variation for when we are highlighting the watermark feature.'
  },
  share_export_header: {
    id: 'ippmString.shareExportHeader',
    defaultMessage: 'Share & export results',
    description: '[Type: Header][Vis.: high] - Header variation for when we are highlighting the share export feature.'
  },
  share_export_subheader: {
    id: 'ippmString.shareExportSubheader',
    defaultMessage: 'Choose a plan to remove watermark, share, export your results and so much more',
    description: '[Type: Header][Vis.: high] - Subheader variation for when we are highlighting the share export feature.'
  },
  dashboard_header: {
    id: 'ippmString.dashboardHeader',
    defaultMessage: 'Publish dashboard',
    description: '[Type: Header][Vis.: high] - Header variation for when we are highlighting the dashboard feature.'
  },
  dashboard_subheader: {
    id: 'ippmString.dashboardSubheader',
    defaultMessage: 'Choose a plan to publish your dashboard, remove watermark and more',
    description: '[Type: Header][Vis.: high] - Subheader variation for when we are highlighting the dashboard feature.'
  },
  // Experiment Strings
  // Headline Component
  ig_1677_header: {
    id: 'ippmString.ig1677Header',
    defaultMessage: 'Unlock more responses',
    description: '[Type: Header][Vis.: high] - Header variation for IG-1677 experiment.'
  },
  ig_1677_sub_header: {
    id: 'ippmString.ig1677Subheader',
    defaultMessage: 'Choose a plan that fits your response needs—a per survey limit, or a monthly account limit.',
    description: '[Type: Header][Vis.: high] - Subheader variation for IG-1677 experiment.'
  },
  ig_1677_standard_monthly_name: {
    id: 'ippmString.ig1677StandardMonthlyName',
    defaultMessage: 'STANDARD MONTHLY 500',
    description: '[Type: Label][Vis.: high] - Plan label for Standard Monthly in IG-1677 experiment.'
  },
  ig_1677_your_current_plan: {
    id: 'ippmString.ig1677YourCurrentPlan',
    defaultMessage: 'YOUR CURRENT PLAN',
    description: '[Type: Label][Vis.: high] - Plan label for current plan in IG-1677 experiment.'
  },
  ig_2066_communicate_response_limits_header: {
    id: 'ippmString.ig2066CommunicateResponseLimitsHeader',
    defaultMessage: 'Get our best features and more responses',
    description: '[Type: Header][Vis.: high] - Header variation for IG-2066 experiment.'
  },
  ig_2066_communicate_response_limits_sub_header: {
    id: 'ippmString.ig2066CommunicateResponseLimitsSubheader',
    defaultMessage: 'Or to send for free, <button type="button" id="return-to-survey" class="wds-button wds-button--link wds-button--text wds-p-0 wds-type--link">return to your survey</button> and remove paid features',
    description: '[Type: Header][Vis.: high] - Subheader variation for IG-2066 experiment.'
  },
  ig_2066_communicate_response_limits_warning_b: {
    id: 'ippmString.ig2066CommunicateResponseLimitsWarningB',
    defaultMessage: 'Your Basic plan only allows 40 responses per survey',
    description: '[Type: Header][Vis.: high] - Warning shown at the bottom of the header for IG-2066 experiment.'
  },
  ig_2066_communicate_response_limits_warning_c: {
    id: 'ippmString.ig2066CommunicateResponseLimitsWarningC',
    defaultMessage: 'BASIC plan only has 40 responses per survey',
    description: '[Type: Header][Vis.: high] - Warning shown at the bottom of the header for IG-2066 experiment.'
  },
  all_advantage_features_plus: {
    id: 'ippmString.allAdvantageFeaturesPlus',
    defaultMessage: 'All Advantage features plus:',
    description: '[Type: Paragraph][Vis.: high] - Sentence preceding a list of additional features'
  },
  all_standard_features_plus: {
    id: 'ippmString.allStandardFeaturesPlus',
    defaultMessage: 'All Standard features plus:',
    description: '[Type: Paragraph][Vis.: high] - Sentence preceding a list of additional features'
  },
  all_premier_features_plus: {
    id: 'ippmString.allPremierFeaturesPlus',
    defaultMessage: 'All Premier features plus:',
    description: '[Type: Paragraph][Vis.: high] - Sentence preceding a list of additional features'
  },
  ippm_default_popular_plans_popular_plans: {
    id: 'ippmString.IppmDefaultPopularPlansPopularPlans',
    defaultMessage: 'Most popular',
    description: '[Type: label][Vis.: high] - label to highlite the most popular plan'
  },
  ippm_default_popular_plans_additional_plans: {
    id: 'ippmString.IppmDefaultPopularPlansAdditionalPlans',
    defaultMessage: 'Additional plans',
    description: '[Type: label][Vis.: high] - label to highlite additional plan'
  },
  audience_header: {
    id: 'ippmString.audienceHeader',
    defaultMessage: 'NEED PEOPLE TO TAKE YOUR SURVEY?',
    description: '[Type: Header][Vis.: high] - question to user'
  },
  responses_header: {
    id: 'ippmString.responsesHeader',
    defaultMessage: 'Responses',
    description: '[Type: Header][Vis.: high] - section header, followed by a line item highlighting the number of responses in a particular plan'
  }
});
export default IPPM_COPY;